var devicesWithPointer = false;

mediaTouchDevices();


$(document).on('click', '.dropdown-item .sidenav .tabs-link', function (e)
{
	$this = $(this);
	$parent = $this.closest('.dropdown-item');
	$parent.find('.tabs-panel.is-active').removeClass('is-active');
	$parent.find('.tabs-link[aria-selected="true"]').attr('aria-selected', 'false');
	$(this).attr('aria-selected', 'true');
	$(this.hash).addClass('is-active');
});

var navHover = null;
var debounceNav = function(callback)
{
    (function()
    {
        var check = navHover;
        setTimeout(function()
        {
            if (check === navHover)
            {
                callback();
            }
        }, 250);
    })();
}

$('.site-header .site-navigation .dropdown-item').on('mouseenter', function ()
{
    navHover = this;
    (function(eventElement)
    {
        debounceNav(function()
        {
            if (devicesWithPointer)
            {
                $(eventElement).find('.dropdown-pane').foundation('open');
            }
        });
    })(this);

}).on('mouseleave', function ()
{
    navHover = false;
	if (devicesWithPointer)
	{
		$(this).find('.dropdown-pane').foundation('close');
	}
}).on('click', function (e)
{
	e.stopImmediatePropagation();
});

$(document).foundation();


// Sticky Header
// window.floatingHeaderLock = false;
// $(window).on(
// 	'scroll',
// 	function ()
// 	{
// 		if ($(window).scrollTop() > 0)
// 		{
// 			$('body').addClass('is-scrolling');
// 			$('.site-header').addClass('site-header--sticked-top');
// 		} else
// 		{
// 			$('body').removeClass('is-scrolling');
// 			$('.site-header').removeClass('site-header--sticked-top');
// 		}
// 	}
// ).on(
// 	'load',
// 	function ()
// 	{
// 		var $window = $(window);
// 		$window.on('scroll', function ()
// 		{
// 			handleStickyHeader();
// 		});
// 	}
// );
// handleStickyHeader();
// var headerHeight = $('.site-header').height() + 20;
// var lastScrollTop = 0;
//
// function handleStickyHeader()
// {
// 	if (window.floatingHeaderLock)
// 	{
// 		return;
// 	}
//
// 	var currentScrollTop = $(window).scrollTop();
//
// 	if (currentScrollTop - headerHeight <= 0)
// 	{
// 		$('body').removeClass('is-scrolling-down is-scrolling-up');
// 	} else if (currentScrollTop > lastScrollTop)
// 	{
// 		$('body').removeClass('is-scrolling-up');
// 		$('body').addClass('is-scrolling-down');
// 	} else
// 	{
// 		$('body').removeClass('is-scrolling-down');
// 		$('body').addClass('is-scrolling-up');
// 	}
//
// 	lastScrollTop = currentScrollTop;
// }
//
// function lockFloatingHeader()
// {
// 	window.floatingHeaderLock = true;
//
// 	setTimeout(function ()
// 	{
// 		window.floatingHeaderLock = false;
// 	}, 3000);
// }

// --------------------------------------------------------------------


$(document).on("click", '.btn-hamburger', function (e)
{
	e.preventDefault();
	$('body').addClass('overlay-opened');
});

$(document).on("click", '.navbar-toggler', function (e)
{
	e.preventDefault();
	$('body').toggleClass('overflow-stopped');
	$('#site-navigation').toggleClass('show');
	$(this).toggleClass('menu-shown');
});

$(document).on("click", '.close-button', function (e)
{
	e.preventDefault();
	$('body').removeClass('overlay-opened');
});

// $(window).on("scroll", function ()
// {
// 	if ($(window).scrollTop() > 0)
// 	{
// 		$(".site-header").addClass("stuck-top");
// 		$("body").addClass("fixed-menu");
// 	} else
// 	{
// 		$(".site-header").removeClass("stuck-top");
// 		$("body").removeClass("fixed-menu");
//
// 	}
// });

$('.select-wrapper').each(function ()
{
	var dropdownParent = $(this);
	$(this).find('.select-picker').select2({
		minimumResultsForSearch: Infinity,
		dropdownParent: dropdownParent,
		width: '100%'
	});
});


$(document).on("click", '.filters-toolbar__toggler', function (e)
{
	e.preventDefault();
	$('.filters-toolbar').slideUp();
});

$(window).on(
	'load',
	function ()
	{
		$('.flickity-enabled').flickity('resize');
	}
);


$(window).on('resize', function ()
{
	mediaTouchDevices();
});


function mediaTouchDevices()
{
	if (window.matchMedia('(any-hover: none)').matches)
	{
		devicesWithPointer = false;
	} else
	{
		devicesWithPointer = true;
	}
}

// --------------------------------------------------------------


// Product Quantity
$('.btn-number').click(function (e)
{
	e.preventDefault();
	fieldName = $(this).attr('data-field');
	type = $(this).attr('data-type');
	var input = $("input[name='" + fieldName + "']");
	var currentVal = parseInt(input.val());
	if (!isNaN(currentVal))
	{
		if (type == 'minus')
		{

			if (currentVal > input.attr('min'))
			{
				input.val(currentVal - 1).change();
			}
			if (parseInt(input.val()) == input.attr('min'))
			{
				$(this).attr('disabled', true);
			}

		} else if (type == 'plus')
		{

			if (currentVal < input.attr('max'))
			{
				input.val(currentVal + 1).change();
			}
			if (parseInt(input.val()) == input.attr('max'))
			{
				$(this).attr('disabled', true);
			}

		}
	} else
	{
		input.val(0);
	}
});

$('.input-number').focusin(function ()
{
	$(this).data('oldValue', $(this).val());
});

$('.input-number').change(function ()
{
	minValue = parseInt($(this).attr('min'));
	maxValue = parseInt($(this).attr('max'));
	valueCurrent = parseInt($(this).val());
	name = $(this).attr('name');
	if (valueCurrent >= minValue)
	{
		$(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr(
			'disabled')
	} else
	{
		alert('Sorry, the minimum value was reached');
		$(this).val($(this).data('oldValue'));
	}
	if (valueCurrent <= maxValue)
	{
		$(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttr('disabled')
	} else
	{
		alert('Sorry, the maximum value was reached');
		$(this).val($(this).data('oldValue'));
	}
});

$(".input-number").keydown(function (e)
{
	// Allow: backspace, delete, tab, escape, enter and .
	if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
		// Allow: Ctrl+A
		(e.keyCode == 65 && e.ctrlKey === true) ||
		// Allow: home, end, left, right
		(e.keyCode >= 35 && e.keyCode <= 39))
	{
		// let it happen, don't do anything
		return;
	}
	// Ensure that it is a number and stop the keypress
	if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode >
		105))
	{
		e.preventDefault();
	}
});
// --------------------------------------------------------------------
// $(window).on("load", function(){
//     // console.log('loaded');
//     var url = window.location.href;
//     var filter_select = $('.filters-select .select-wrapper select');
//     filter_select.on('change', function(){
//         var value = $(this).find('option:selected').val();
//         console.log(value);
//     });
// });
$(window).on("load", function ()
{
	const collFilters = $('.filter-selector');
	var url = "";
	if (collFilters.length > 0)
	{
		collFilters.each(function (index_i)
		{
			collFilters.eq(index_i).on('change', function ()
			{
				url = location.href;
				var newTags = [];
				collFilters.each(function (index_j)
				{
					var options = collFilters.eq(index_j).find("option:selected");
					newTags.push(options.val());
				});
				if (newTags.length)
				{
					var query = newTags.join('+');
					url = url + '/' + query;
				}
			});

		});
		$("#filter-submit").on("click", function ()
		{
			location.href = url;
		});
	}


	// Add to cart
	var sideCart = window.sideCart || [];
	$('form[action="/cart/add"]').on('submit', function (e)
	{
		e.preventDefault();
		var formData = {quantity: 1};
		$(this).find('input, select').each(function ()
		{
			formData[$(this).prop('name')] = $(this).val();
		});

		sideCart.push('add-item', formData);
		sideCart.push('open');
	});

	$('[data-wait-for-sidecart]').each(function() {
		$(this).addClass('sidecart-loaded');
	});
});
$(function ()
{
	var mega_menus = $("div[class*='mega-menu-']");
	var menu_head = $("ul.navbar-nav li");
	mega_menus.each(function (index)
	{
		var mega_menu = $(this);
		var handle = mega_menu.data('rel');
		for (var i = 0; i < menu_head.length; i++)
		{
			var rel_handle = menu_head.eq(i).data('dropdown-rel');
			var chevron_btn = menu_head.eq(i).find('button.dropdown-toggle');
			if (handle == rel_handle)
			{
				menu_head.eq(i).removeClass('has-submenu');
				menu_head.eq(i).find('submenu-regular').remove();
				menu_head.eq(i).append(mega_menu);
				chevron_btn.removeClass('hide');
			}
		}
	})
});

$(document).ready(function()
{
	// Get mobile menu caught up to current page
	var url = window.location.pathname;
	if (!url.match(/collections|pages/).length)
	{
		return;
	}

	var link = $('.mobile-overlay .menu').find('a[href*="' + url + '"]');

	var parentLink = link.parent().parent().prev('a');
	var path = [];

	while(parentLink.length)
	{
		path.push(parentLink);
		parentLink = parentLink.parent().parent().prev('a');
	}

	var delay = 50;
	path.reverse().forEach(function(l, i) {
		(function(time, element) {
			setTimeout(function()
			{
				element.trigger('click');
			});
		})(delay * i, l);
	});

});

$('.features-video-modal').on('closed.zf.reveal', function () {
    $(this).find('.modal-video').attr('src', '');
});

$(".features-video-modal").on('open.zf.reveal', function () {
    var _videoSource = $(this).find('.modal-video').data('src');
    $(this).find('.modal-video').attr('src', _videoSource);
});



var $testimonialCarousel = $(document).find('.testimonial .carousel-init');
$testimonialCarousel.flickity({
    pageDots: false,
    contain: true,
    wrapAround: true,
    cellAlign: 'left',
    selectedAttraction: 0.3,
    friction: 0.9
});